import { render } from "./solicitacao.vue?vue&type=template&id=df9e278e&scoped=true"
import script from "./solicitacao.vue?vue&type=script&lang=js"
export * from "./solicitacao.vue?vue&type=script&lang=js"

import "./solicitacao.vue?vue&type=style&index=0&id=df9e278e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df9e278e"]])

export default __exports__